import { asyncRouterMap, constantRouterMap } from '@/config/router.config'
import { testRouterRouter } from '@/config/module/testRouter.config'
import store from '../../store'
import getDisableMenuList from '@/config/disableMenuConfig'
import getMenuReplacerList from '@/config/routerNameReplacerConfig'

function getPermissionTree(list, disableMenuList, replacerList) {
  const newList = []
  list.forEach((route, index, arr) => {
    if (route.name && disableMenuList.includes(route.name)) {
      // console.error("=====这是禁用页面（菜单）===",route.name)
    } else {
      replaceRouteName(route, replacerList)
      if (!route.ignorePermissions && !route.hidePermissionTree) {
        const newItem = {
          permissionName: route.meta.title,
          permissionKey: route.name
        }
        if (route.children && route.children.length > 0) {
          newItem.children = getPermissionTree(route.children, disableMenuList, replacerList)
        }
        newList.push(newItem)
      }
    }
  })
  return newList
}

/**
 *
 * @param routeList 路由信息列表
 * @param disableMenuList 禁用路由（页面）
 * @param replacerList 路由标题配置信息
 * @returns {*[]}
 */
function getPermissionList(routeList, disableMenuList, replacerList) {
  const list = []
  routeList.forEach((route, index, arr) => {
    if (route.name && !disableMenuList.includes(route.name)) {
      replaceRouteName(route, replacerList)
      list.push(route.name)
    }
    if (route.children && route.children.length > 0) {
      let childrenList = getPermissionList(route.children, disableMenuList)
      list.push(...childrenList)
    }
  })
  return list
}

//获取所有的权限信息（开发、测试使用）
function getAllPermissionInfo(list) {
  const newList = []
  list.forEach((route, index, arr) => {
    if (!route.ignorePermissions) {
      const newItem = {
        permissionName: route.meta.title,
        permissionKey: route.name
      }
      if (route.children && route.children.length > 0) {
        newItem.children = getAllPermissionInfo(route.children)
      }
      newList.push(newItem)
    }
  })
  return newList
}

/**
 * //替换路由名字
 * @param route 路由信息
 * @param replacerList 需要替换的配置信息
 */
function replaceRouteName(route, replacerList) {
  //  meta: { title: '云仓', keepAlive: false}
  if (replacerList && replacerList.length > 0 && route && route.name && route.meta) {
    let findItem = replacerList.find(item => item.name === route.name)
    if (findItem) {
      route.meta.title = findItem.title
    }
  }
}

/**
 *
 * @param routerMap 初始路由数据
 * @param roles 角色路由
 * @param ignorePermission 忽略权限控制的路由
 * @param disableMenuList   禁用路由列表
 * @param replacerList   新的路由名称配置表
 * @returns {*[]}
 */
function filterAsyncRouter(routerMap, roles, ignorePermission, disableMenuList, replacerList) {
  const newRouters = []//使用新的数据，不要覆盖原始数据
  routerMap.forEach(route => {
    replaceRouteName(route, replacerList)//替换路由标题
    if (route.path === '*') {
      newRouters.push({ ...route })
    } else if (route.children && route.children.length > 0) {
      let childrenRoutes = filterAsyncRouter(route.children, roles, route.ignorePermissions, disableMenuList, replacerList)
      if (childrenRoutes.length > 0) {
        newRouters.push({ ...route, children: childrenRoutes })
      }
    } else if (route.name && !disableMenuList.includes(route.name) && (ignorePermission || route.ignorePermissions || !!roles.permissionList.includes(route.name) || route.hidden)) {
      newRouters.push({ ...route })
    }
    newRouters.forEach(item => {
      let hidden = true//如果所有的子菜单都是隐藏的。则隐藏父菜单
      if (item && item.children && item.children.length > 0) {
        for (let i = 0, len = item.children.length; i < len; i++) {
          if (!item.children[i].hidden) {
            hidden = false
            break
          }
        }
        item.hidden = hidden
      }
    })
  })
  return newRouters
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { roles } = data
        let disableMenuList = getDisableMenuList()
        let replacerList = getMenuReplacerList()
        const accessedRouters = filterAsyncRouter(asyncRouterMap, roles, [], disableMenuList, replacerList)
        if (store.getters.appConfig.isDev) {
          accessedRouters[0].children.push(...testRouterRouter)//追加测试的组件代码
        }
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    },
    GetAllPermissionTree({ commit }) {
      return new Promise(resolve => {
        let disableMenuList = getDisableMenuList()
        let replacerList = getMenuReplacerList()
        let list = getPermissionTree(asyncRouterMap[0].children, disableMenuList, replacerList)
        const treeList = list.filter(item => item.children && item.children.length > 0)
        resolve(treeList)
      })
    },
    GeAllPermissionList({ commit }) {
      return new Promise(resolve => {
        let disableMenuList = getDisableMenuList()
        let replacerList = getMenuReplacerList()
        const list = getPermissionList(asyncRouterMap, disableMenuList, replacerList)
        resolve(list)
      })
    }
  }
}

export default permission
